const EXPORT_MOTION_FREEZE_STYLE_ATTR = 'data-export-motion-freeze';

/**
 * Animations off + reduced-motion on the capture surface before html2canvas.
 * Returns a restore callback (idempotent).
 */
export function freezeExportCaptureMotion(root: HTMLElement): () => void {
  root.setAttribute('data-export-capture', 'true');
  root.setAttribute('data-export-reduced-motion', 'true');

  let styleEl = document.head.querySelector<HTMLStyleElement>(
    `style[${EXPORT_MOTION_FREEZE_STYLE_ATTR}="true"]`,
  );
  if (styleEl == null) {
    styleEl = document.createElement('style');
    styleEl.setAttribute(EXPORT_MOTION_FREEZE_STYLE_ATTR, 'true');
    styleEl.textContent = `
[data-export-capture="true"],
[data-export-capture="true"] * {
  animation: none !important;
  animation-duration: 0s !important;
  animation-delay: 0s !important;
  transition: none !important;
  transition-duration: 0s !important;
  scroll-behavior: auto !important;
}
`.trim();
    document.head.appendChild(styleEl);
  }

  let restored = false;
  return () => {
    if (restored) {
      return;
    }
    restored = true;
    root.removeAttribute('data-export-capture');
    root.removeAttribute('data-export-reduced-motion');
    const remaining = document.querySelectorAll('[data-export-capture="true"]');
    if (remaining.length === 0) {
      styleEl?.remove();
    }
  };
}

/** Fonts ready + two rAF + settle tick before capture. */
export async function waitForExportPreflight(root?: HTMLElement): Promise<void> {
  if (root?.getAttribute('data-export-settle') === 'skip') {
    return;
  }

  if (typeof document !== 'undefined' && document.fonts?.ready) {
    await document.fonts.ready;
  }

  await new Promise<void>((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        resolve();
      });
    });
  });

  await new Promise<void>((resolve) => {
    setTimeout(resolve, 0);
  });
}
